/**
 * {
 *     "code": 0,
 *     "data": {
 *         "dir": "upload/2024/3/9/",
 *         "expires": 1709963357959,
 *         "uploadHost": "https://static-test.micun.com",
 *         "accessId": "LTAI5tDsCs7zY6UPdU5Dw9fN",
 *         "policy": "eyJleHBpcmF0aW9uIjogIjIwMjQtMDMtMDlUMTM6NDk6MTcuOTU5MjAyMzU3WiIsImNvbmRpdGlvbnMiOiBbeyJidWNrZXQiOiAibWljdW50ZXN0LW9zcy1idWNrZXQiIH1dfQ==",
 *         "signature": "ICKSgmjxxX2MOz4vAF04bqgD6qw=",
 *         "downloadUrl": "https://api.pre.micun.cn:10443/assistant/oss/download/object/v1?objectName=upload%2F2024%2F3%2F9%2F"
 *     }
 * }
 */

import { useFetch } from "../hooks";
export var useAssistantOssGetPostObjectInfoV1 = function useAssistantOssGetPostObjectInfoV1() {
  var _useFetch = useFetch(),
    post = _useFetch.post;
  return function () {
    return post({
      url: '/assistant/oss/get/post/object/info/v1'
    });
  };
};